function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Fragment } from 'react';
import { Form, Button } from 'mkui-fd';
import { getUUID } from './util';
/**
 * @description: 初始化表格字段
 * @param {type} 
 * @return: 
 */

export var initColumns = function initColumns(_ref, deleteRecordHandle, copyRecordHandle) {
  var config = _ref.config,
      form = _ref.form,
      componentMapper = _ref.componentMapper,
      setComponentProps = _ref.setComponentProps,
      setComponentValue = _ref.setComponentValue,
      setComponentRules = _ref.setComponentRules,
      disabled = _ref.disabled,
      leastOneRecord = _ref.leastOneRecord;
  var _config$property$deta = config.property.detailTableFields,
      detailTableFields = _config$property$deta === void 0 ? [] : _config$property$deta;

  if (detailTableFields.length) {
    var tableColumns = detailTableFields.map(function (col) {
      return {
        title: col.property.name,
        key: col.identifier,
        dataIndex: col.identifier,
        render: function render(text, record, index) {
          return renderComponent({
            record: record,
            col: col,
            form: form,
            componentMapper: componentMapper,
            setComponentProps: setComponentProps,
            setComponentValue: setComponentValue,
            setComponentRules: setComponentRules,
            index: index
          });
        }
      };
    });
    var sequence = {
      title: '序号',
      dataIndex: 'index',
      fixed: 'left',
      width: 70,
      key: 'index'
    };
    var options = {
      title: '操作',
      dataIndex: 'uuid',
      fixed: 'right',
      width: 100,
      key: 'option'
    };

    var tableOptions = _objectSpread({}, options, {
      render: function render(text, record, index) {
        return React.createElement(Fragment, null, React.createElement(Button, {
          icon: "trash",
          type: "danger",
          shape: "clear",
          disabled: disabled || leastOneRecord && record.index === 1,
          onClick: function onClick() {
            return deleteRecordHandle(text);
          }
        }), React.createElement(Button, {
          icon: "copy",
          shape: "clear",
          onClick: function onClick() {
            return copyRecordHandle(text);
          }
        }));
      }
    });

    tableColumns.unshift(sequence);
    tableColumns.push(tableOptions);
    return tableColumns;
  }

  return [];
};
/**
 * @description: render 绑定组件
 * @param {type} 
 * @return: 
 */

var renderComponent = function renderComponent(_ref2) {
  var record = _ref2.record,
      col = _ref2.col,
      form = _ref2.form,
      componentMapper = _ref2.componentMapper,
      setComponentProps = _ref2.setComponentProps,
      setComponentValue = _ref2.setComponentValue,
      setComponentRules = _ref2.setComponentRules,
      index = _ref2.index;
  var getFieldDecorator = form.getFieldDecorator;
  var identifier = col.identifier,
      defaultValue = col.property.defaultValue;
  return React.createElement(Form.Item, null, getFieldDecorator("".concat(identifier, "-").concat(record.uuid), {
    initialValue: setComponentValue(col, defaultValue),
    rules: setComponentRules(col)
  })(getComponentByType(col, componentMapper, setComponentProps, index)));
};

var getComponentByType = function getComponentByType(col, componentMapper, setComponentProps, index) {
  var type = col.type,
      _col$property = col.property,
      dateType = _col$property.dateType,
      dateFormat = _col$property.dateFormat;
  var Field = null; // 时间组件做特殊处理

  if (type === 'DateTimeInput') {
    if (dateType === 'SINGLE') {
      if (dateFormat === 'yyyy-MM-dd') {
        Field = componentMapper.DateInput;
      } else {
        Field = componentMapper.MonthPicker;
      }
    } else {
      Field = componentMapper.RangePicker;
    }
  } else {
    Field = componentMapper[type];
  }

  return React.createElement(Field, _extends({
    theme: "surround"
  }, setComponentProps(col, index)));
};
/**
 * @description: 双向绑定
 * @param {type} 
 * @return: 
 */


export var bindingFieldValue = function bindingFieldValue(config, form, dataSource, setComponentValue) {
  var setFieldsValue = form.setFieldsValue;

  if (dataSource.length) {
    for (var i = 0; i < dataSource.length; i++) {
      var ds = dataSource[i];
      var uuid = ds.uuid;

      var _loop = function _loop(key) {
        if (key !== 'uuid' && key !== 'index') {
          var _config$property$deta2 = config.property.detailTableFields,
              detailTableFields = _config$property$deta2 === void 0 ? [] : _config$property$deta2;
          var fieldConfig = detailTableFields.find(function (cfg) {
            return cfg.identifier === key;
          });
          var v = setComponentValue(fieldConfig, ds[key]);
          setFieldsValue(_defineProperty({}, "".concat(key, "-").concat(uuid), v));
        }
      };

      for (var key in ds) {
        _loop(key);
      }
    }
  }
};
/**
 * @description: 获取 table 内数据
 * @param {type} 
 * @return: 
 */

export var initDataSource = function initDataSource(value, leastOneRecord) {
  if (value.length) {
    return value.map(function (v, index) {
      return _objectSpread({
        index: index + 1,
        uuid: getUUID()
      }, v);
    });
  }

  if (leastOneRecord) {
    return [{
      index: 1,
      uuid: getUUID()
    }];
  }

  return [];
};
export var bindingRecord = function bindingRecord(form, uuid, newUuid) {
  var getFieldsValue = form.getFieldsValue,
      setFieldsValue = form.setFieldsValue;
  var allRecord = getFieldsValue();
  var fieldKeys = Object.keys(allRecord).filter(function (k) {
    return k.indexOf(uuid) > 0;
  });

  for (var j = 0; j < fieldKeys.length; j++) {
    var fieldKey = fieldKeys[j];
    var key = fieldKey.substring(0, fieldKey.indexOf('-'));
    setFieldsValue(_defineProperty({}, "".concat(key, "-").concat(newUuid), allRecord[fieldKey]));
  }
}; // export const getData = (values, detailTableFields) => {
//     let result = [];
//     // 去重获取 uuids
//     const keys = Object.keys(values).map(key => key.slice(key.indexOf('-') + 1))
//     const uuidSet = new Set(keys)
//     const uuids = Array.from(uuidSet)
//     for (let i = 0; i < uuids.length; i++) {
//         const uuid = uuids[i];
//         const fieldKeys = Object.keys(values).filter(k => k.indexOf(uuid) > 0);
//         const field = {};
//         for (let j = 0; j < fieldKeys.length; j++) {
//             const fieldKey = fieldKeys[j];
//             const k = fieldKey.substring(0, fieldKey.indexOf('-'));
//             field[k] = filterCommitData(values[fieldKey], k, detailTableFields);
//         }
//         result.push(field)
//     }
//     return result
// }
// const filterCommitData = (value, key, fields) => {
//     const fieldConfig = fields.find(field => field.identifier === key);
//     if (value && fieldConfig && fieldConfig.type === 'DateTimeInput') {
//         const { property: { dateType, dateFormat } } = fieldConfig;
//         if (dateType === 'SINGLE') {
//             return moment(value).format(dateFormat.toUpperCase())
//         } else {
//             const [startTime, endTime] = value;
//             return {
//                 startTime: moment(startTime).format('YYYY-MM-DD'),
//                 endTime: moment(endTime).format('YYYY-MM-DD'),
//             }
//         }
//     }
//     return value
// }

export var getValidateResult = function getValidateResult(errors) {
  var errorValues = Object.values(errors);

  for (var i = 0; i < errorValues.length; i++) {
    if (errorValues[i] && errorValues[i].length) {
      return false;
    }
  }

  return true;
};
//# sourceMappingURL=service.js.map
